import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'

const DeleteRowDialog = ({openDialog,cancelRemoveRow,confirmRemoveRow, }) => {
  return (
    <Dialog
    open={openDialog}
    onClose={cancelRemoveRow}
    BackdropProps={{
      style: {
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        boxShadow: "none", // Adjust the opacity as needed (0.3 is lighter)
      },
    }}
  >
    <DialogTitle>Confirm Delete</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete this row?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={cancelRemoveRow} color="primary">
        Cancel
      </Button>
      <Button onClick={confirmRemoveRow} color="secondary">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
  )
}

export default DeleteRowDialog